import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { nodeTypeIcon } from './node-icons';

const CACHE = new Map<string, string>();

/**
 * A crisp, theme-coloured SVG data-URI of a node-type icon for canvas (cytoscape)
 * rendering — the canvas can't read CSS tokens, so the caller passes the resolved
 * colour. Memoised per type+colour. Replaces the old emoji-as-image.
 */
export function nodeIconImg(type: string, color: string): string {
  const key = `${type}|${color}`;
  let u = CACHE.get(key);
  if (!u) {
    const Icon = nodeTypeIcon(type);
    const svg = renderToStaticMarkup(createElement(Icon, { color, size: 24, strokeWidth: 1.75 }));
    u = 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
    CACHE.set(key, u);
  }
  return u;
}
